export const APP_NAME = 'TSG eCart';

export const APP_DESCRIPTION = 'Premium quick-commerce grocery platform';

export const DEFAULT_CURRENCY = 'INR';

export const DEFAULT_TIMEZONE = 'Asia/Kolkata';

export const DEFAULT_LOCALE = 'en-IN';

export const REQUEST_ID_HEADER = 'x-request-id';

export const CSRF_HEADER = 'x-csrf-token';

/** Roles recognized by the platform. Permission logic is implemented in Phase 2. */
export const USER_ROLES = ['CUSTOMER', 'STAFF', 'ADMIN'] as const;

export type UserRole = (typeof USER_ROLES)[number];
